import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "C:/nexus/data-gh/guide/src/components/layout/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`If you're already comfortable with a concept, feel free to skip videos if not you can watch them in order.`}</p>
    <h1>{`HTML / CSS / Javascript`}</h1>
    <p>{`I would highly recommend to code along when watching this video: `}<a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLs-CRkeogneYoJvn5mdvuyymB5AW6OHUj"
      }}>{`Youtube video`}</a></p>
    <h1>{`Good introduction to d3`}</h1>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=TOJ9yjvlapY&list=PL55RiY5tL51r1NlkJLzVhui1S480gnuNG"
      }}>{`Youtube video`}</a></p>
    <h1>{`More D3`}</h1>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLs-CRkeogneZLK9sKeKdLTrZ_FAh-XOqK"
      }}>{`Youtube video`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      